module.exports = __webpack_public_path__ + "static/media/we-empty.4f93e604.svg";